/* LYVOI: preselect the cart "Complete the set" upsell to the size that completes the set, in the color already in the cart.
   Cart has a carry-on (20/22) -> suggest 28" Check in; cart has a big case (28/30) -> suggest 20" Carry on (10-12 fix:
   it used to always suggest 28", even with a 28" already in the cart). Copy is swapped to match.
   Upsell block renders the product's first variant (20" Silver) by default; this just changes the dropdowns
   and fires the theme's own change handler, so price/variant id update through theme code. */
(function () {
  var sizeWanted = '28';
  var cartColor = null;
  var suitcaseCount = 0;
  var unitPrices = [];   // list price of every suitcase unit already in the cart (cents)
  var cartCasesNow = 0;  // what those units cost now, after line discounts (cents)
  var COPY_BIG = 'Most customers pair a checked case with a 20″ carry-on. <strong>Add a second case and get 15% off the lower-priced one.</strong>';

  function loadCartColor() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cases = (cart.items || []).filter(function (i) { return /suitcase/i.test(i.product_title || ''); });
        suitcaseCount = cases.reduce(function (n, i) { return n + i.quantity; }, 0);
        unitPrices = [];
        cartCasesNow = 0;
        cases.forEach(function (i) {
          for (var k = 0; k < i.quantity; k++) unitPrices.push(i.original_price);
          cartCasesNow += i.final_line_price;
        });
        var item = cases[0];
        cartColor = item && item.options_with_values
          ? (item.options_with_values.find(function (o) { return /colou?r/i.test(o.name); }) || {}).value || null
          : null;
        var hasBig = cases.some(function (i) { return /28|30/.test(i.variant_title || ''); });
        sizeWanted = hasBig ? '20' : '28';
      })
      .catch(function () {});
  }

  function pick(select, test) {
    var opt = Array.prototype.find.call(select.options, function (o) { return !o.disabled && test(o.value); });
    if (opt && select.value !== opt.value) {
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function apply(picker) {
    if (picker.dataset.lyvoiDefaulted) return;
    picker.dataset.lyvoiDefaulted = '1';
    picker.querySelectorAll('select').forEach(function (s) {
      var name = s.getAttribute('name') || '';
      if (/colou?r/i.test(name) && cartColor) pick(s, function (v) { return v === cartColor; });
    });
    picker.querySelectorAll('select').forEach(function (s) {
      var name = s.getAttribute('name') || '';
      if (/size/i.test(name)) pick(s, function (v) { return v.indexOf(sizeWanted) !== -1; });
    });
    if (sizeWanted === '20') {
      var card = picker.closest('cart-drawer-upsell') || picker.parentElement;
      var desc = card && Array.prototype.find.call(card.querySelectorAll('p, div, span'), function (e) {
        return e.children.length <= 1 && /Most customers pair/.test(e.innerHTML);
      });
      if (desc) desc.innerHTML = COPY_BIG;
    }
  }

  // 10-15: card stays visible at any count (like Riigid); copy follows the live automatic discounts:
  // 0-1 case = block settings (2ND CASE 15% OFF).
  // 10-22: 3+ cases = "1st full, 2nd 15% off, 3rd+ 25% off", charged as per-count "N-CASE BUNDLE SAVINGS"
  // (same % on every unit, floored per unit to the cent at checkout; mirrors _third_case_25_20261022.py).
  var TIER_PCT = { 3: 0.1334, 4: 0.1625, 5: 0.18, 6: 0.1917, 7: 0.2, 8: 0.2063, 9: 0.2112, 10: 0.215, 11: 0.2182, 12: 0.2209 };
  var TIER_COPY = {
    2: ['Add a third case: <strong>2nd case 15% off, 3rd 25% off.</strong>', '<strong>Add to set</strong>'],
    3: ['Every extra case: <strong>25% off.</strong>', '<strong>Add to set</strong>']
  };
  // what adding one case at `price` really adds to the cart total, once the next tier kicks in
  function addedCost(price) {
    var pct = TIER_PCT[Math.min(suitcaseCount + 1, 12)];
    var after = 0;
    // +1e-6: 30000 * 0.1334 = 4001.9999… in floats, checkout takes 40.02
    unitPrices.concat([price]).forEach(function (p) { after += p - Math.floor(p * pct + 1e-6); });
    return after - cartCasesNow;
  }
  function applyTierCopy() {
    var copy = TIER_COPY[Math.min(suitcaseCount, 3)];
    if (!copy) return;
    document.querySelectorAll('cart-drawer-upsell').forEach(function (u) {
      var desc = u.querySelector('.upsell__desc');
      var btn = u.querySelector('.upsell__add-btn:not([disabled]) > span');
      if (desc && desc.innerHTML !== copy[0]) desc.innerHTML = copy[0];
      if (btn && btn.innerHTML !== copy[1]) btn.innerHTML = copy[1];
    });
  }

  function scan() {
    applyTierCopy();
    document.querySelectorAll('cart-drawer .upsell__variant-picker, #CartDrawer .upsell__variant-picker, .cart-drawer .upsell__variant-picker')
      .forEach(apply);
    setTimeout(syncPrices, 50);
  }

  // .com's older upsell block switches data-id on variant change but never repaints the price
  // (showed $220 while adding the $340 28"). Repaint from the block's own variants JSON.
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function syncPrices() {
    document.querySelectorAll('cart-drawer-upsell').forEach(function (u) {
      try {
        var js = u.querySelector('script[type="application/json"]');
        var v = JSON.parse(js.textContent).find(function (x) { return String(x.id) === String(u.dataset.id); });
        var rp = u.querySelector('.upsell__price .regular-price'), cp = u.querySelector('.upsell__price .compare-price');
        // at 2+ cases the card shows what adding this case really adds to the total, not list price
        if (v && rp) rp.textContent = money(suitcaseCount >= 2 ? addedCost(v.price) : v.price);
        if (v && cp && v.compare_at_price) cp.textContent = money(v.compare_at_price);
      } catch (e) {}
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer-upsell')) setTimeout(function () { syncPrices(); applyTierCopy(); }, 50);
  }, true);

  new MutationObserver(function () {
    if (document.querySelector('.upsell__variant-picker:not([data-lyvoi-defaulted])')) loadCartColor().then(scan);
  }).observe(document.documentElement, { childList: true, subtree: true });

  loadCartColor().then(scan);
})();
